

































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class DigStartAnalysisCmp extends Vue {
  @Prop()
  private message: any;
  private projects: any[] = [];
  private tables: any[] = [];
  private messageChange() {
    this.$emit("update:message", this.message);
  }
  /**
   * @description 获取项目列表
   */
  private fetchProjects() {
    axios.get("api/wajue/projects").then(({ data }) => {
      resHandle(this, data).then(() => {
        this.projects = data.data;
      });
    });
  }
  /**
   * @description 获取数据表格
   */
  private fetchTables() {
    this.message.table_id = "";
    const params: any = {
      params: {
        project_id: this.message.project_id
      }
    };
    axios.get("api/wajue/tables", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.tables = data.data;
        this.tables.unshift({ table_id: "", 表格名称: "全部数据表格" });
      });
    });
  }
  /**
   * @description 开始分析
   */
  private start() {
    if (!this.message.project_id) {
      this.$message.warning("请选择一个项目");
      return;
    }
    this.$emit("start");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchProjects();
  }
}
